import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { EmbeddedEditPageProps } from '../src/edit-page/EmbeddedEditPage.tsx';

export const EmbeddedEditPageLoader: LoadableType<EmbeddedEditPageProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-edit-pageEmbeddedEditPage" */ '../src/edit-page/EmbeddedEditPage.tsx'
			)
		).EmbeddedEditPage,
});
